import axios from 'axios'

export const state = {
  saleRepsTypes: {},
}

export const getters = {
  listSaleRepTypes (state) {
    return state.saleRepsTypes
  },
}

export const mutations = {
  SET_SALE_REP_TYPES (state, saleRepsTypes) {
    state.saleRepsTypes = saleRepsTypes
  },
  PUSH_SALE_REP_TYPE (state, type) {
    state.saleRepsTypes.data.push({name: type})
  },
}

export const actions = {
  getSaleRepTypes({ commit }, params = {
    limit: 500,
  }) {
    return axios.get('/sale_rep_types', { params }).then(({ data }) => {
      return commit('SET_SALE_REP_TYPES', data)
    })
  },
  getListSaleRepTypes({ commit }, params = {}) {
    return axios.get('/sale_rep_types', { params })
  },

  pushSaleRepType({commit}, type) {
    return commit('PUSH_SALE_REP_TYPE', type)
  }
}
